import * as React from "react";
const ContactView = React.lazy(() => import("./ContactView"));

export { ContactView };
